import { NgModule } from '@angular/core';
import {
    TranslocoModule,
    provideTransloco,
    translocoConfig,
} from '@jsverse/transloco';

import { environment } from 'environments/environment';
import { TranslocoHttpLoader } from 'app/core/transloco/transloco.http-loader';

@NgModule({
    exports: [TranslocoModule],
    providers: [
        provideTransloco({
            config: translocoConfig({
                availableLangs: [
                    { id: 'en', label: 'English' },
                    { id: 'it', label: 'Italiano' },
                ],
                defaultLang: 'it',
                fallbackLang: 'it',
                reRenderOnLangChange: true,
                prodMode: environment.production,
                missingHandler: {
                    logMissingKey: !environment.production,
                    useFallbackTranslation: true,
                },
            }),
            loader: TranslocoHttpLoader,
        }),
    ],
})
export class TranslocoCoreModule {}
